import Toastify from "toastify-js";

class ToastService {
  COLORS = {
    alert: {
      background: "oklch(var(--er)",
      color: "oklch(var(--erc)",
    },
    notice: {
      background: "oklch(var(--in)",
      color: "oklch(var(--inc)",
    },
    success: {
      background: "oklch(var(--su)",
      color: "oklch(var(--suc)",
    },
    error: {
      background: "oklch(var(--er)",
      color: "oklch(var(--erc)",
    },
    default: {
      background: "oklch(var(--in)",
      color: "oklch(var(--inc)",
    },
  };

  success(args) {
    this.toast({
      ...args,
      type: "success",
    });
  }

  alert(args) {
    this.toast({
      ...args,
      type: "alert",
    });
  }

  toast({
    text,
    duration = 3000,
    gravity = "top",
    position = "right",
    close = true,
    avatar,
    callback,
    type,
    multiple,
  }) {
    if (duration === undefined || duration === null || duration === 0)
      duration = 3000;
    if (!gravity) gravity = "top";
    if (!position) position = "right";
    if (close === undefined || close === null) close = true;

    duration = Number(duration);
    close = close === "true" || close === true;

    const toast = Toastify({
      text,
      duration,
      gravity,
      position,
      close,
      avatar,
      style: {
        background:
          this.COLORS[type]?.background || this.COLORS.default.background,
        color: this.COLORS[type]?.color || this.COLORS.default.color,
      },
      stopOnFocus: true,
      callback,
    });

    if (!multiple) {
      // If any element with class .toastify exists with the same text,
      // don't show the toast.
      try {
        if (document.querySelector(`.toastify[data-text="${text}"]`)) {
          return;
        }
      } catch {}
    }

    toast.showToast();
    toast.toastElement.dataset.text = text;
    toast.toastElement.dataset.morphPermanent = true;
    toast.toastElement.dataset.turboPermanent = true;
  }
}

export default ToastService;
